import React from 'react';
import {bem} from '../../utils/bem';
import Button from './Button';

const block = bem('listFilters');

const ListFilters = ({
											 filters,
											 activeFilters = null,
											 onClickActiveFilter = null,
											 onClickReset = null,
											 resetCount = 0
										 }) => (
	<div className={block({sticky: true})}>
		<div className={block('content')}>
			<div className={block('controls')}>
				<div className={block('filters')}>
					{filters}
				</div>
				{activeFilters && <div className={block('filtersResults')}>
					<ul className={block('tags')}>
						{activeFilters.map(item => (
							<li className={block('tagItem')} key={item.key}>
								<Button
									label={item.label}
									onClick={() => onClickActiveFilter && onClickActiveFilter(item)}
									modifiers={{listFiltersTag: true}}
									icon={{
										name: 'close',
										width: 13,
										height: 13
									}}/>
							</li>
						))}
						<li className={block('tagItem', {reset: true})}>
							<Button
								label={resetCount}
								onClick={onClickReset}
								modifiers={{listFiltersTag: true, listFiltersResetTag: true}}
								icon={{
									name: 'reload',
									width: 23,
									height: 21
								}}
							/>
						</li>
					</ul>
				</div>}
			</div>
		</div>
	</div>
);

export default ListFilters;
